import {
  API_TYPES,
  PostSpendingControlNotificationBodySchema,
  type SpendingControlNotificationEvent,
  SpendingControlNotificationResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation } from "@tanstack/react-query";

interface CreateSpendingControlNotificationParams {
  workplaceId: string;
  event: SpendingControlNotificationEvent;
  weekStartDate?: Date;
  additionalHoursRequested?: number;
}

export function useCreateSpendingControlNotification() {
  return useMutation({
    mutationFn: async (params: CreateSpendingControlNotificationParams) => {
      const { workplaceId, event, weekStartDate, additionalHoursRequested } = params;

      const url = `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/spending-control-notifications`;

      const response = await post({
        url,
        data: {
          data: {
            type: API_TYPES.spendingControlNotification,
            attributes: {
              event,
              weekStartDate,
              additionalHoursRequested,
            },
            relationships: {
              workplace: {
                data: {
                  type: API_TYPES.workplace,
                  id: workplaceId,
                },
              },
            },
          },
        },
        bodySchema: PostSpendingControlNotificationBodySchema,
        responseSchema: SpendingControlNotificationResponseSchema,
      });

      return response.data.data.attributes;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CREATE_SPENDING_CONTROL_NOTIFICATION_FAILURE,
    },
  });
}
